import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as Website from '../Config/Website.js';


const Current = () => {
  gsap.registerPlugin(ScrollTrigger);
  let sectionItem
  let navItem

  for (let i = 1; i < 7; i++) {
    navItem = '#js-gnavItem' + i
    sectionItem = '#js-section' + i
    ScrollTrigger.create({
      // markers: true,
      trigger: sectionItem,
      start: 'top center',
      end: 'bottom center',
      toggleClass: {
        targets: navItem,
        className: Website.classList.act,
      }
    })
  }
}

const init = () => {
  Current();
}
export default init;